import {
    createContext,
    useContext,
    useMemo,
    useReducer
} from 'react';
import { truckInspectionsActionConstants } from '@/Store/Actions/truck_inspections_action';

// Create a context to hold the state
export const TruckInspectionsContext = createContext();

// Define the initial state
const initialState = {
    queryInformation: null,
    cachedPages: []
};

// Define the reducer function to handle state transitions
const reducer = (state, action) => {
    switch (action.type) {
        case truckInspectionsActionConstants.SAVE_QUERY_INFORMATION:
            return {
                ...state,
                queryInformation: action?.queryInformation
            };
        case truckInspectionsActionConstants.CACHE_PAGE_DATA:
            return {
                ...state,
                cachedPages: [
                    ...state?.cachedPages,
                    {
                        key: action?.key,
                        pageData: action?.pageData
                    }
                ]
            };
        default:
            throw new Error();
    }
};

export const TruckInspectionsProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    const truckInspectionsState = useMemo(() => {
        return { ...(state || {}) };
    }, [state]);

    // In this return value, we passed-in children as the CONSUMER of the PROVIDER
    // This will able children components to access the data inside the context
    return (
        <TruckInspectionsContext.Provider value={{ truckInspections: truckInspectionsState, dispatch }}>
            {children}
        </TruckInspectionsContext.Provider>
    );
};

export const useTruckInspectionsContext = () => {
    return useContext(TruckInspectionsContext);
};
